export const PaymentActionType = {
	SET_PAYMENT_PREPARED_DATA: "SET_PAYMENT_PREPARED_DATA",
};
